export default __webpack_public_path__ + "static/media/img_trust.bf747b3e.svg";